import React from 'react'
import { SpinnerIcon } from 'src/components'
import Icon from '../Icon'

const Loader = domProps => <Icon {...domProps} icon={SpinnerIcon} fixedWidth pulse />

export default Loader
